import React, { useState, useEffect, useCallback, useRef } from 'react'

import ProfilePicture from 'components/profile/profile-picture'
import SmoothCollapse from 'react-smooth-collapse'

import { connect } from 'react-redux'

import Icon from 'components/icon/icon'

import {
    setStatus
} from 'state/actions'

import {
    doClickEventListeners,
} from 'utils'

const statuses = [
    {
        key: null,
        label: 'Online',
        description: 'Ready to chat'
    }, {
        key: 'AWAY',
        label: 'Away',
        description: 'Away from keyboard'
    }, {
        key: 'BUSY',
        label: 'Busy',
        description: 'Busy with something'
    }, {
        key: 'OFFLINE',
        label: 'Offline',
        description: 'Offline'
    }
]

const BigChatStatus = ({
    userData,
    setStatus
}) => {
    const [expanded, setExpanded] = useState(false)
    const outerRef = useRef()

    const currentStatus = statuses.find(status => status.key === userData.status_if_online)

    const updateStatus = key => {
        setStatus(userData, key)

        setTimeout(() => {
            setExpanded(false)
        }, 200)
    }

    const handleClickOutside = useCallback(e => {
        if (!outerRef.current) {
            return
        }

        if (!e || !outerRef.current.contains(e.target)) {
            setExpanded(false)
        }
    }, [])

    useEffect(() => {
        doClickEventListeners(handleClickOutside)

        return () => {
            doClickEventListeners(handleClickOutside, true)
        }
    }, [])

    return (
        <div
            className='big-chat-status'
            ref={outerRef}
        >
            <button
                onClick={() => setExpanded(!expanded)}
                className={expanded ? 'open' : ''}
            >
                <div>
                    <em className={`online-dot ${userData.status_if_online} visible`} />
                    <ProfilePicture user={userData} isTiny={true} />
                </div>
                <div>
                    <h4 dangerouslySetInnerHTML={{ __html: `${userData.first_name} ${userData.last_name}` }} />
                    {currentStatus &&
                        <span>
                            {currentStatus.label}
                        </span>
                    }
                </div>
                <Icon name={`fe-chevron-down`} />
            </button>
            <SmoothCollapse expanded={expanded}>
                <ul className='status-dropdown'>
                    {statuses.map(({
                        key,
                        label,
                        description
                    }) => {
                        const isActive = currentStatus ? currentStatus.key === key : false

                        return (
                            <li key={key}>
                                <button
                                    onClick={() => updateStatus(key)}
                                    className={isActive ? 'active' : ''}
                                >
                                    <h4>
                                        {label}
                                    </h4>
                                    <span>
                                        {description}
                                    </span>
                                </button>
                            </li>
                        )
                    })}
                </ul>
            </SmoothCollapse>
        </div>
    )
}


const mapStateToProps = state => {
    return {

    }
}

export default connect(mapStateToProps, {
    setStatus
})(BigChatStatus)